export default __webpack_public_path__ + "static/tia2018-4584f531854cb2c33f6def4e1d74f9a3.jpg";